import { Checkbox } from "@mui/material";
import type { ChangeEvent } from "react";
import { useId, useState } from "react";
import TextWithEndTagInput from "./TextWithEndTagInput";

interface WflSubInputProps {
  defaultBoolValue: boolean;
  defaultTextValue: string;
  onInputChange?: (...values: unknown[]) => void;
  disabled?: boolean;
}

function WflSubInput({
  defaultBoolValue,
  defaultTextValue,
  onInputChange,
  disabled,
}: WflSubInputProps){
  const [checked, setChecked] = useState<boolean>(defaultBoolValue);
  const id = useId();
  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setChecked(e.target.checked);
    if (onInputChange) {
      onInputChange(e.target.checked);
    }
  };
  const onTextChange = (...values: unknown[]): void => {
    if (onInputChange) {
      onInputChange(checked, ...values);
    }
  }

  return (
    <div>
      <label className="flex items-center" htmlFor={id}>
        <Checkbox checked={checked} disabled={disabled} id={id} onChange={onChange} />
        <p className="ml-2">Within Functional Limits</p>
      </label>
      {!checked && (
        <TextWithEndTagInput
          defaultValue={defaultTextValue}
          disabled={disabled}
          endText="Degrees"
          onInputChange={onTextChange}
          type="number"
        />
      )}
    </div>
  );
}

export default WflSubInput;
